import { useCallback, useEffect } from "react";

export const KEY_NAME_ENTER = "Enter";
export const KEY_NAME_UP = "ArrowUp";
export const KEY_NAME_DOWN = "ArrowDown";
export const KEY_NAME_TAB = "Tab";
export const KEY_NAME_SPACE = " ";
export const KEY_NAME_ESC = "Escape";
export const KEY_EVENT_TYPE = "keydown";

export default function useKeyDownDetector(callbackFn) {
    const handleKeyPress = useCallback(
        (event) => {
            callbackFn(event);
        },
        [callbackFn],
    );

    useEffect(() => {
        document.addEventListener(KEY_EVENT_TYPE, handleKeyPress, false);

        return () => {
            document.removeEventListener(KEY_EVENT_TYPE, handleKeyPress, false);
        };
    }, [handleKeyPress]);
}
